export default __webpack_public_path__ + "static/media/img_illust01.ec12d817.png";